import ConsentGatedIframe from './ConsentGatedIframe';

export default ConsentGatedIframe;
